import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "site_header",
  class: "header mobile-menu-hide"
}
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header-photo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/jomans_header_image.png",
    alt: "Joshua Manlunas"
  })
], -1)
const _hoisted_4 = { class: "header-titles" }
const _hoisted_5 = { class: "social-links" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "header-buttons" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "copyrights" }, "© 2022 All rights reserved.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName), 1),
        _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createVNode(_component_Nav),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMediaLinks, (smedialink) => {
          return (_openBlock(), _createElementBlock("li", {
            key: smedialink.name
          }, [
            _createElementVNode("a", {
              href: smedialink.link,
              target: "_blank"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass('fab fa-'+ smedialink.name)
              }, null, 2)
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("a", {
        href: _ctx.downloadUrl,
        target: "_blank",
        class: "btn btn-primary"
      }, "Download CV", 8, _hoisted_8)
    ]),
    _hoisted_9
  ]))
}